var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0747 3.06089C12.7815 2.72455 12.4333 2.45775 12.0502 2.27572C11.667 2.09369 11.2563 2 10.8415 2C10.4268 2 10.0161 2.09369 9.63289 2.27572C9.24972 2.45775 8.90158 2.72455 8.60837 3.06089L7.99985 3.75857L7.39132 3.06089C6.79905 2.38184 5.99576 2.00035 5.15816 2.00035C4.32057 2.00035 3.51728 2.38184 2.92501 3.06089C2.33273 3.73994 2 4.66092 2 5.62124C2 6.58157 2.33273 7.50255 2.92501 8.1816L3.53353 8.87928L7.99985 14L12.4662 8.87928L13.0747 8.1816C13.368 7.84543 13.6007 7.44628 13.7595 7.00697C13.9183 6.56765 14 6.09678 14 5.62124C14 5.14571 13.9183 4.67484 13.7595 4.23552C13.6007 3.79621 13.368 3.39706 13.0747 3.06089V3.06089Z",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.140e25d788b34139b55f9cf47baf7204.svg";
export { ForwardRef as ReactComponent };